<template>
    <div>
        <b-form-group
            id="fieldset-1"
            :description="description"
            :label="text"
            :label-for="name"
            :label-class="labelClass"
            :label-size="labelSize"
        >
            <div :id="`input_${name}`" class="photo-group">
                <div class="photo-control" v-on:click="$_selectFile">
                    <em class="fas fa-plus-circle photo-icon"></em>
                    <span class="photo-title">Foto uploaden</span>
                    <span
                        :id="`selected_${name}`"
                        class="float-right photo-name"
                        >{{ fileName }}</span
                    >
                </div>
                <!-- Invisible file selector -->
                <input
                    v-bind="$attrs"
                    ref="fileSelector"
                    v-show="false"
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/bmp, image/png, image/tif, image/gif;capture=camera"
                    :id="name"
                    :name="name"
                    :value="value"
                    @change="$_onChange"
                    :data-fieldname="name"
                />
                <div
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="d-block invalid-feedback"
                >
                    {{ errorMessage }}
                </div>
            </div>
        </b-form-group>
    </div>
</template>

<script>
    export default {
        name: 'UploadFoto',

        props: {
            description: { type: String, required: false },
            name: { type: String, required: false, default: 'UploadFoto-input' },
            text: { type: String, required: false, default: '' },
            labelSize: { type: String, required: false, default: '' },
            value: [String, Number],
            labelClass: { type: String, default: 'font-weight-normal' },
            state: { type: Boolean, default: true }
        },

        data() {
            return {
                fileName: 'Geen bestand gekozen',
                error: ''
            };
        },
        computed: {
            errorMessage() {
                if (!this.state) {
                    return this.$t('loadFileChoose');
                } else {
                    return this.error;
                }
            }
        },

        methods: {
            /**
             * File selected event handler
             * @param  {object} event [holds the selected files]
             */
            $_onChange(event) {
                const files = event.currentTarget.files;
                this.error = '';
                if (files.length > 0) {
                    this.fileName = files[0].name;
                    // get the bound data-fieldname property
                    const dataFieldname =
                        this.$refs.fileSelector.getAttribute('data-fieldname');
                    // read file content
                    this.readFileContent(files)
                        .then((result) => {
                            // send selected file event
                            this.$emit(
                                'selected',
                                result,
                                dataFieldname,
                                this.fileName
                            );
                        })
                        .catch((error) => {
                            this.error = error;
                        });
                } else {
                    this.fileName = 'Geen bestand gekozen';
                }
            },

            /**
             * Show the image file selector
             */
            $_selectFile() {
                // call click on the hidden file selector
                this.$refs.fileSelector.click();
            },

            /**
             * Read the image content
             * @param  {Array} files   [selected image files]
             * @return {object}        [Promise object]
             */
            readFileContent(files) {
                return new Promise((resolve, reject) => {
                    // het geselecteerde bestand
                    const file = files[0];
                    if (file && file.size > 20971520) {
                        reject(new Error('Bestand is te groot'));
                        return;
                    }
                    // bestand extensie
                    const tokens = this.fileName.toLowerCase().match(/\.([^\.]+)$/);
                    if (tokens && tokens.length > 1) {
                        const ext = tokens[1];
                        switch (ext) {
                            case 'jpg':
                            case 'jpeg':
                            case 'bmp':
                            case 'png':
                            case 'tif':
                            case 'gif':
                                break;
                            default:
                                reject(
                                    new Error(
                                        'Extensie is niet toegestaan, gebruik: jpg, jpeg, bmp, png, tif of gif'
                                    )
                                );
                                return;
                        }
                    } else {
                        reject(
                            new Error(
                                'Extensie is niet toegestaan, gebruik: jpg, jpeg, bmp, png, tif of gif'
                            )
                        );
                        return;
                    }

                    try {
                        // read file
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const data = e.target.result;
                            const type = e.target.result
                                .split(';')[0]
                                .replace('data:image/', '');
                            // result
                            resolve({
                                data,
                                type
                            });
                        };
                        reader.readAsDataURL(file);
                    } catch (error) {
                        reject(error);
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
.photo-group {
    display: block;
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
}

.photo-control {
    background: #fff;
    cursor: pointer;
    border-radius: 0.25rem;
}

.photo-icon {
    color: #007ac9;
    margin-left: 10px;
}

.photo-title {
    margin-left: 10px;
    margin-right: 10px;
}

.photo-name {
    margin-left: 10px;
    margin-right: 15px;
}
</style>
